import { useEffect, useState } from 'react';
import { Circles } from 'react-loading-icons';

import { getMovieById } from '../../../util/apis/MovieAPI';
export default function MovieRatingHeader({ content }) {
  const [showFullDesc, setShowFullDesc] = useState(false);

  const toggleDescription = () => setShowFullDesc(!showFullDesc);

  const getDescription = () => {
    if (!content?.overview) return '';
    if (showFullDesc || content.overview.length <= 500) {
      return content.overview;
    }
    return content.overview.slice(0, 500) + '...';
  };
  return (
    <>
      {content && content.genres ? (
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 p-4 sm:p-6 md:p-10 max-w-screen-xl mx-auto">
          <img
            src={`https://image.tmdb.org/t/p/original/${content.poster_path}`}
            // className="rounded-xl border-2 aspect-video w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-lg"
            className={'rounded-xl border-2 aspect-poster w-64 sm:w-80'}
            loading="lazy"
            alt={content.name}
          />

          <div className="flex flex-col gap-4 text-center lg:text-left max-w-3xl px-4">
            <h2 className="text-white font-bold text-3xl sm:text-4xl md:text-5xl font-hind pt-4 lg:pt-0">
              {content.title}
            </h2>

            <h3 className="text-faded font-hind text-sm sm:text-base md:text-lg text-justify">
              {getDescription()}
              {content.overview.length > 500 && (
                <button
                  onClick={toggleDescription}
                  className="text-blue-400 ml-1 underline text-sm"
                >
                  {showFullDesc ? 'Show Less' : 'Read More'}
                </button>
              )}
            </h3>

            <h4 className="text-faded font-hind text-base sm:text-lg">
              <span className="font-bold">Released</span>:{' '}
              {content.release_date}
            </h4>

            <h5 className="text-faded font-hind text-base sm:text-lg">
              <span className="font-bold">Runtime</span>: {content.runtime} min
            </h5>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              {content.genres.map((genre, index) => (
                <div
                  key={index}
                  className="rounded-3xl text-sm font-hind text-faded px-4 py-2 bg-blue-950 whitespace-nowrap"
                >
                  {genre.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <Circles />
      )}
    </>
  );
}
